import React from 'react';
import DatePicker from './DatePicker';

const DateRangePicker = ({ dateFrom, setDateFrom, dateTo, setDateTo }) => {
  return (
    <div className="date-selection">
      <div className="option-label">加入時期</div>
      <div className="date-range">
        <DatePicker 
          value={dateFrom} 
          onChange={(date) => setDateFrom(date)}
          placeholder="開始日"
        />
        <span className="date-separator">〜</span>
        <DatePicker 
          value={dateTo} 
          onChange={(date) => setDateTo(date)}
          placeholder="終了日"
        />
      </div>
    </div>
  );
};

export default DateRangePicker;